import { Dock } from "../types/dock";
import { LogEntry } from "../types/logEntry";

export const GetUser = () => {
    return fetch(`${process.env.REACT_APP_BACKEND_URL}/projectlog/getuser`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    }).then(res => res.json());
}

export const GetAllDropDownData = () => {
    return fetch(`${process.env.REACT_APP_BACKEND_URL}/projectlog/optionjson`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    }).then(res => res.json());
}

export const StartWork = (username: string) => {
    return fetch(`${process.env.REACT_APP_BACKEND_URL}/projectlog/startwork`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(username)
    }).then(res => res.json());
}

export const GetLogsForUser = (headerId: number) => {
    return fetch(`${process.env.REACT_APP_BACKEND_URL }/projectlog/${headerId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(res => res.json());
}

export const GetProjectLogTabs = () => {
    return fetch(`${process.env.REACT_APP_BACKEND_URL }/projectlog/tabs`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(res => res.json());
}

export const InsertLog = (log: LogEntry, isForce: boolean) => {
    return fetch(`${ process.env.REACT_APP_BACKEND_URL }/${isForce ? "projectlog/tankForce" : "projectlog"}`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(log)
    }).then(res => res.json());
}

export const GetDocks = (dock: Dock) => {
    return fetch(`${ process.env.REACT_APP_BACKEND_URL }/projectlog/docks`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dock)
    }).then(res => res.json());
}
